import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';

import type { AiSuggestionsPlugin } from '../aiSuggestionsPluginType';
import { aiSuggestionsPluginKey } from '../pm-plugins/main';
import { thinkingPluginKey } from '../pm-plugins/thinking-plugin';
import {
	addEntryPointClickedAnalytics,
	fireAiInteractionInitiatedUnifiedAnalytics,
} from '../ui/utils/analytics';

import type { StartThinkingAction } from './types';

export const startThinkingAction: (
	api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined,
) => StartThinkingAction =
	(api: ExtractInjectionAPI<AiSuggestionsPlugin> | undefined) =>
	(options): boolean => {
		return (
			api?.core?.actions.execute(({ tr }) => {
				if (options?.entryPoint) {
					// TODO: EDITOR-8150 - interactionID is a client-generated placeholder; it may
					// be sourced from the backend (or elsewhere) once the unified suggested-edits
					// analytics structure is finalised.
					const interactionID = crypto.randomUUID();
					addEntryPointClickedAnalytics(api?.analytics?.actions)(tr, options.entryPoint);
					fireAiInteractionInitiatedUnifiedAnalytics(
						api?.analytics?.actions,
						options.entryPoint,
						interactionID,
					);
					// Persist the interaction's instrumentation ID so a later
					// `aiFeedback submitted` event can reuse it and correlate the user's
					// thumbs feedback back to this originating interaction.
					tr.setMeta(aiSuggestionsPluginKey, {
						action: 'SET_INTERACTION_ID',
						interactionID,
					});
				}
				tr.setMeta(thinkingPluginKey, {
					status: 'thinking',
				});
				return tr;
			}) || false
		);
	};
